<template>
  <v-data-table
    :headers="headers"
    :loading="!!!users.length"
    :items="users"
    :items-per-page="10"
    :sort-by="['id']"
    sort-desc
  >
    <template v-slot:body.prepend>
      <tr>
        <td colspan="1"></td>
        <td>
          <v-text-field
            v-model="filter.first_name"
            :label="$t('DATA_TABLE.FILTER')"
          ></v-text-field>
        </td>
        <td>
          <v-text-field
            v-model="filter.last_name"
            :label="$t('DATA_TABLE.FILTER')"
          ></v-text-field>
        </td>
        <td>
          <v-text-field
            v-model="filter.username"
            :label="$t('DATA_TABLE.FILTER')"
          ></v-text-field>
        </td>
        <td>
          <v-text-field
            v-model="filter.position"
            :label="$t('DATA_TABLE.FILTER')"
          ></v-text-field>
        </td>
        <td>
          <v-text-field
            v-model="filter.email"
            :label="$t('DATA_TABLE.FILTER')"
          ></v-text-field>
        </td>
        <td>
          <v-text-field
            v-model="filter.mobilePhone"
            :label="$t('DATA_TABLE.FILTER')"
          ></v-text-field>
        </td>
        <td>
          <v-select
            v-model="filter.role"
            :loading="!!!roles"
            :items="roles"
            :label="$t('DATA_TABLE.FILTER')"
            small-chips
            multiple
            dense
          ></v-select>
        </td>
        <td colspan="2"></td>
      </tr>
    </template>

    <template v-slot:item.roles="{ item }">
      <v-chip
        v-for="role in item.roles"
        :key="role.id"
        class="mr-1"
        color="primary"
        x-small
        dark
        outlined
      >
        {{ role.slug }}
      </v-chip>
    </template>

    <template v-slot:item.action="{ item }">
      <div class="text-center">
        <v-menu transition="scale-transition" origin="center center">
          <template v-slot:activator="{ on }">
            <v-btn text icon x-small v-on="on">
              <v-icon>mdi-cog</v-icon>
            </v-btn>
          </template>
          <v-list dense>
            <v-list-item @click="$emit('edit', item)">
              <v-list-item-title>
                <v-icon class="mr-1" small>mdi-account-edit</v-icon>
                {{ $t('ITEM.EDIT') }}
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
    </template>
  </v-data-table>
</template>

<script>
export default {
  name: 'Users',

  data: () => ({
    filter: {
      first_name: '',
      last_name: '',
      username: '',
      position: '',
      email: '',
      mobilePhone: '',
      role: []
    },

    roles: []
  }),

  computed: {
    users() {
      return this.$store.state.user.users;
    },

    headers() {
      return [
        {
          text: this.$t('ITEM.ID'),
          align: 'left',
          sortable: true,
          value: 'id'
        },
        {
          text: this.$t('PROFILE.FIRST_NAME'),
          value: 'person.first_name',
          filter: value => this.filter_column(value, 'first_name')
        },
        {
          text: this.$t('PROFILE.LAST_NAME'),
          value: 'person.last_name',
          filter: value => this.filter_column(value, 'last_name')
        },
        {
          text: this.$t('USERS.USERNAME'),
          value: 'username',
          filter: value => this.filter_column(value, 'username')
        },
        {
          text: this.$t('PROFILE.POSITION'),
          value: 'person.work_profile.position',
          filter: value => this.filter_column(value, 'position')
        },
        {
          text: this.$t('PROFILE.EMAIL'),
          value: 'email',
          filter: value => this.filter_column(value, 'email')
        },
        {
          text: this.$t('PROFILE.MOBILE_PHONE'),
          value: 'person.work_profile.mobile_phone',
          filter: value => this.filter_column(value, 'mobilePhone')
        },
        {
          text: this.$t('USERS.ROLES'),
          value: 'roles',
          filter: value => {
            if (!this.filter.role.length) return true;

            return this.filter.role.some(v => {
              return Object.values(value).some(role => role.slug == v);
            });
          }
        },
        {
          text: this.$t('DATA_TABLE.ACTIONS'),
          value: 'action',
          align: 'center'
        }
      ];
    }
  },

  created() {
    this.$store.dispatch('user/retrieveUsers').then(({ data }) => {
      this.$store.commit('user/retrievedUsers', data);
    });

    this.$store.dispatch('role/retrieveRolesForUsers').then(({ data }) => {
      let roles = [];
      data.forEach(role => {
        roles.push(role.slug);
      });
      this.roles = roles;
    });
  },

  methods: {
    filter_column(value, param) {
      if (!this.filter[param]) return true;
      if (!value) return false;

      let lcValue = (value + '').toLowerCase(); // (value + '') means value.toString()
      let lcName = this.filter[param].toLowerCase();

      return lcValue.indexOf(lcName) > -1;
    }
  }
};
</script>
